import PropTypes from 'prop-types';
import React from 'react';
import { createSelector } from 'reselect';
import entityComposition from '../common/classes/entityComposition';
import ModalNotification from './modalNotification';
import Toaster from './toaster';
const notificationList = state => state.notification.list;
const modalListSelector = createSelector([notificationList], list => list.filter(item => item.type && item.type === 'modal'));
const toastListSelector = createSelector([notificationList], list => list.filter(item => item.type && item.type === 'toast'));
const Notifier = ({
  modalList,
  toastList
}) => /*#__PURE__*/React.createElement("div", {
  className: "t-notifier"
}, /*#__PURE__*/React.createElement(ModalNotification, {
  list: modalList
}), /*#__PURE__*/React.createElement(Toaster, {
  list: toastList
}));
Notifier.propTypes = {
  modalList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  toastList: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};
export { Notifier as TestNotifier, modalListSelector, toastListSelector };
export default entityComposition(Notifier, [], {
  modalList: modalListSelector,
  toastList: toastListSelector
});